<template>
  <div v-if="status === 'success'" class="szw-row__between szw-w-full szw-h-fit szw-rounded-lg szw-p-2 szw-bg-section-static" e2e-id="szw-event-overview-banner">
    <team-section :team="props.home" :is-small-widget-container-size="props.isSmallWidgetContainerSize" mode="banner" direction="reversed" />

    <div class="szw-col__center">
      <div class="szw-row szw-text-2xl szw-font-bold">
        <template v-if="!props.upcomingEventStartTime.isUpcoming">
          <span class="szw-w-10 szw-text-center">{{ props.home.score }}</span>
          <span>:</span>
          <span class="szw-w-10 szw-text-center">{{ props.away.score }}</span>
        </template>
        <template v-else>
          <span class="szw-text-center">{{ props.upcomingEventStartTime.date }}</span>
        </template>
      </div>

      <div :class="['szw-p-1 szw-rounded-lg szw-text-center szw-leading-4', { 'szw-bg-section-hover': highlightStatus }]">
        <span :class="['szw-text-sm szw-text-center', { 'szw-text-xs': isSmallWidgetContainerSize }]">
          {{ !props.upcomingEventStartTime.isUpcoming ? loc(props.matchStatus, langId) : props.upcomingEventStartTime.time }}
        </span>
      </div>
    </div>

    <team-section :team="props.away" :is-small-widget-container-size="props.isSmallWidgetContainerSize" mode="banner" />
  </div>

  <event-overview-banner-skeleton v-if="status === 'loading'" :is-small-widget-container-size="isSmallWidgetContainerSize" />
</template>

<script setup>
import TeamSection from '@/__core__/components/headers/common-header/sections/TeamSection.vue'
import EventOverviewBannerSkeleton from './EventOverviewBannerSkeleton.vue'
import { inject } from 'vue'

const props = defineProps({
  home: {
    type: Object,
    default: () => ({})
  },
  away: {
    type: Object,
    default: () => ({})
  },
  matchStatus: {
    type: String,
    default: ''
  },
  isSmallWidgetContainerSize: {
    type: Boolean,
    default: false
  },
  upcomingEventStartTime: {
    type: Object,
    default: () => ({
      isUpcoming: false,
      date: '',
      time: ''
    })
  },
  highlightStatus: {
    type: Boolean,
    default: false
  }
})

const status = inject('status', 'error')
const langId = inject('langId', '')
</script>
